import { Container } from "components";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "services/api";

export const CorperatessDetails = () => {
      const params = useParams();
    
      const [corperators, setCorperators] = useState([]);
    
    const fetchCorperateData = async () => {
        try {
          const response = await api.get(`/corporate-entities/${params.id}`);
          setCorperators(response.data.data);
          console.log("fetchCorperateData :", response.data.data);
        } catch (error) {
          console.log("fetchCorperateData:", error);
        }
      };

      useEffect( () =>  {
        fetchCorperateData();
      }, [])
  return (
    <>
      <Container>
        <div class="content-wrapper">
          <div class="container-xxl flex-grow-1 container-p-y ">
            <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0"></div>
            <div className="container-xxl flex-grow-1 container-p-y">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <Link to="/corporates">Corporates </Link>
                  </li>
                  <li class="breadcrumb-item active ">Corporates Details</li>
                </ol>
              </nav>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-12">
                          <small className="card-text text-uppercase">
                            About
                          </small>
                          <ul className="list-unstyled mb-4 mt-3">
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-user text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Name
                              </span>
                              <span>{corperators?.name} </span>
                            </li>
                             <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-user text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Email
                              </span>
                              <span>{corperators?.contact_email} </span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-list-details text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Phone No
                              </span>
                              <span>{corperators?.contact_phone} </span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-messages text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Industry
                              </span>
                              <span >
                                {corperators?.industry?.name}
                              </span>
                            </li>
                           
                          </ul>
                        </div>
                        {/* <div className="col-md-8 col-12">
                          <ul className="list-unstyled mb-4 mt-3">
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-user text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Middle Name
                              </span>
                              <span>{corperators?.middle_name} </span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-bell text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Phone No
                              </span>
                              <span>{corperators?.profile?.phone_no} </span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-calendar text-heading"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Date Of Birth
                              </span>
                              <span>
                                {moment(corperators?.profile?.dob).format(
                                  "DD-MM-YYYY"
                                )}{" "}
                              </span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-phone-call"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Address
                              </span>
                              <span>{corperators?.profile?.address}</span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-map-pin"></i>
                              <span className="fw-medium mx-2 text-heading">
                                City
                              </span>
                              <span>{corperators?.profile?.city}</span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-map-pin"></i>
                              <span className="fw-medium mx-2 text-heading">
                                State
                              </span>
                              <span>{corperators?.profile?.state}</span>
                            </li>
                            <li className="d-flex align-items-center mb-3">
                              <i className="ti ti-mail"></i>
                              <span className="fw-medium mx-2 text-heading">
                                Postal Code
                              </span>
                              <span>{corperators?.profile?.postal_code}</span>
                            </li>
                          </ul>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
